import axios from "axios";
import {AxiosConfig} from "./axios.config";
import {getStateAwareUrl} from "../utils/utils";
import {AuthHeader} from "configs/auth.token";
import {error_manager} from "./error_manager";

export const get = (url, no_cache=false) =>
	axios.get(getStateAwareUrl(url), AxiosConfig(no_cache)).then(response => response.data);

export const get_with_creds = (url) =>
	axios.get(getStateAwareUrl(url), { headers: { Authorization: AuthHeader() }, withCredentials: true }).then(response => response.data);

export const get_response = (url, no_cache=false) =>
	axios.get(getStateAwareUrl(url), AxiosConfig(no_cache)).then(response => response);

export const get_response_with_abort_controller = (url, abortControllerSignal, no_cache = false) => {
	const config = AxiosConfig(no_cache)
	config.signal = abortControllerSignal;
	return axios.get(getStateAwareUrl(url), config).then(response => response);
}

export const post = (url, data, no_cache=false) =>
	axios.post(getStateAwareUrl(url), data, AxiosConfig(no_cache)).then(response => response.data);

export const post_response = (url, data, no_cache=false) =>
	axios.post(getStateAwareUrl(url), data, AxiosConfig(no_cache)).then(response => response);

export const patch = (url, data) =>
	axios.patch(getStateAwareUrl(url), data, AxiosConfig()).then(response => response.data);

export const patch_response = (url, data) =>
	axios.patch(getStateAwareUrl(url), data, AxiosConfig()).then(response => response);

export const put = (url, data) =>
	axios.put(getStateAwareUrl(url), data, AxiosConfig()).then(response => response.data);

export const put_response = (url, data) =>
	axios.put(getStateAwareUrl(url), data, AxiosConfig()).then(response => response);

export const delete_ = url =>
	axios.delete(getStateAwareUrl(url), AxiosConfig()).then(response => response.data);

export const delete_response = url =>
	axios.delete(getStateAwareUrl(url), AxiosConfig()).then(response => response);

export const get_pdf = url =>{
	fetch(url, {
		headers: new Headers({
			"Authorization": AuthHeader()
		})
	})
		.then((response) => response.blob())
		.then((blob) => {
			const _url = window.URL.createObjectURL(blob);
			window.open(_url, "_blank").focus();
		}).catch((err) => error_manager('', err));
}